// AIR-13553
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import min from 'lodash/min'
import map from 'lodash/map'
import { Box, Flex, getPaletteColor, Text } from 'pcln-design-system'
import moment from 'moment'
import { flyGaLogic } from '../../util/flyGaLogic'
import { LowestPriceFlexDatesTileVariant } from '../LowestPriceFlexDatesTileVariant/LowestPriceFlexDatesTileVariant'
import { fireFlyConditions } from '../../constants/fireflyCondition'

const FlexContainerVariant = styled(Flex)`
  flex-flow: column;
  padding: 8px;

  background: ${props =>
    props.updatedFlexDatesOWStyling
      ? 'none'
      : getPaletteColor('background.light')};

  border: ${props =>
    props.updatedFlexDatesOWStyling
      ? 'none'
      : '1px solid' + getPaletteColor('background.light')};
`

const FlexDatesTilesWrapper = styled(Flex)`
  justify-content: center;
  float: left;
  min-width: 100%;
`

const FlexDatesTilesContainerStyles = {
  overflowX: 'auto',
  clear: 'both',
}

class FlexDatesTilesContainer extends React.PureComponent {
  /**
   * Generate URL that links to new search with all of the same params as the current
   * search, except for a different travel date.
   * @param origin
   * @param destination
   * @param formatDepartDateUrl
   * @param cabinClass
   * @param passengerUrl
   * @returns {string}
   */

  constructor(props) {
    super(props)
    this.newFlexDateSetiImpressionFired = false
    this.flexDateFlyqlOw = false
  }
  static getSearchURL = ({
    searchOrigin,
    searchDestination,
    formatDepartDateUrl,
    cabinClass,
    passengerUrl,
  }) => {
    const sliceUrl = `${searchOrigin}-${searchDestination}-${formatDepartDateUrl}/`
    return `/m/fly/search/${sliceUrl}?cabin-class=${cabinClass}&${passengerUrl}`
  }

  getExpressDealFlexDates = (expressDealFlexDates, altDateObj) => {
    return expressDealFlexDates.find(expressDealFlexDate => {
      return (
        expressDealFlexDate.departDate === altDateObj.departDate &&
        expressDealFlexDate.returnDate === altDateObj.returnDate &&
        expressDealFlexDate.fare < altDateObj.fare
      )
    })
  }

  getFlexDates = () => {
    const {
      minRetailPrice,
      minRetailStops,
      calendarPricing,
      travelDate,
      tripType,
      searchOrigin,
      searchDestination,
    } = this.props

    const expressDealInfo = this.props.expressDealInfo || {}

    const origDepartDate = moment(travelDate).startOf('day')
    const today = moment().startOf('day')
    const currencySymbol = '$' // ToDo: Update currencySymbol based on User Selected Currency
    let isflexDatesAvailable = false
    /**
     * Get the origin, destination, cabinClass and passengerURl from the first available calendar Pricing Object
     * These parameters are consistent across all calendarPricing Objects
     */
    const flexDatesDetails = calendarPricing.find(flexDate => {
      return flexDate.destination1 && flexDate.origin1
    })

    /**
     * If none of the calendarPricing Object return Origin and Destination, return null.
     * This is a rare case scenario.
     */
    if (!flexDatesDetails) {
      return null
    }

    // Get the days difference between Travel(Depart) Date and Current Day(today)
    const dateDiff = origDepartDate.diff(today, 'd')

    /**
     * create an array of -/+ 1 or 2 days from travel date(origDepartDate)
     * flexDatesRange contains list of dates
     */
    const flexDatesRange = []

    const daysAfterSelectedDate = 2
    const daysBeforeSelectedDate =
      dateDiff >= daysAfterSelectedDate
        ? -1 * daysAfterSelectedDate
        : -1 * dateDiff

    const startDate = moment(travelDate).add(daysBeforeSelectedDate, 'days')
    const endDate = moment(travelDate).add(daysAfterSelectedDate, 'days')

    /**
     * Create an Array of Date Objects ranging from startDate to endDate
     */
    while (startDate.isSameOrBefore(endDate)) {
      flexDatesRange.push(startDate.clone())
      startDate.add(1, 'days')
    }

    const expressDeal = expressDealInfo.searchedDate
    const expressDealFlexDates = expressDealInfo.flexDates

    let formatFlexDates = []

    let lastCabinClass
    const flexDatesMap = flexDatesRange.map(flexDatesRangeNode => {
      let cabinClass = flexDatesDetails.cabinClass || 'ECO'
      lastCabinClass = cabinClass
      let flexDatePrice
      let flexDatePriceExists = false
      let isOriginalDepartDate = false
      let flexDateSearchUrl = ''
      let numStops
      let passengerUrl = flexDatesDetails.passengerUrl || ''
      const formatDepartDateUrl = moment(flexDatesRangeNode).format('YYYYMMDD')
      const flexDateDaysDiff = flexDatesRangeNode.diff(origDepartDate, 'd')
      if (flexDateDaysDiff === 0) {
        flexDatePrice = Math.ceil(minRetailPrice)
        flexDatePriceExists = !!minRetailPrice
        isOriginalDepartDate = true
        numStops = minRetailStops

        if (
          expressDeal &&
          expressDeal.pricingInfo &&
          expressDeal.pricingInfo.totalFare < minRetailPrice
        ) {
          numStops = 7
          flexDatePrice = Math.ceil(expressDeal.pricingInfo.totalFare)
        }
      } else {
        /**
         * Check for calendarPricingObject corresponding to flexDatesRangeNode.
         */
        const altDateObj = calendarPricing.find(
          calendarPricingNode =>
            calendarPricingNode.departDate ===
            moment(flexDatesRangeNode).format('YYYY-MM-DD')
        )

        if (altDateObj) {
          /* If flexDatesAvailable is true then the Carousel component is displayed */
          if (!isflexDatesAvailable && !fireFlyConditions.isFireFly()) {
            isflexDatesAvailable = true
          }
          cabinClass = altDateObj.cabinClass
          flexDatePrice = Math.ceil(altDateObj.fare)
          flexDatePriceExists = true
          passengerUrl = altDateObj.passengerUrl
          numStops = altDateObj.numStops

          if (expressDealFlexDates) {
            const expressDealFlexDate = this.getExpressDealFlexDates(
              expressDealFlexDates,
              altDateObj
            )
            if (expressDealFlexDate) {
              numStops = 7
              flexDatePrice = Math.ceil(expressDealFlexDate.fare)
            }
          }
        } else {
          cabinClass = cabinClass || lastCabinClass
        }

        flexDateSearchUrl = FlexDatesTilesContainer.getSearchURL({
          searchOrigin,
          searchDestination,
          formatDepartDateUrl,
          cabinClass,
          passengerUrl,
        })

        const encodedPrice = encodeURIComponent(btoa(flexDatePrice))

        flexDateSearchUrl =
          flexDateSearchUrl + `&prev-flex-date-price=${encodedPrice}`
      }
      return {
        flexDatePrice,
        formatDepartDateUrl,
        minRetailPrice,
        flexDate: moment(flexDatesRangeNode).format('ddd M/D'),
        flexDatePriceExists,
        isOriginalDepartDate,
        currencySymbol,
        flexDateDaysDiff,
        flexDateSearchUrl,
        numStops,
        tripType,
      }
    })

    const lowestPrice = min(map(flexDatesMap, 'flexDatePrice'))
    const savings = Math.floor(minRetailPrice - lowestPrice)
    let displayLowestPrice = false

    const lowestPriceDates = flexDatesMap.filter(({ flexDatePrice }) => {
      return flexDatePrice === lowestPrice
    })

    if (lowestPriceDates.length === 1) {
      displayLowestPrice = true
      lowestPriceDates[0].hasLowestPrice = true
    }

    const displaySavings = displayLowestPrice && savings > 0

    formatFlexDates = flexDatesMap.map(eachDate => {
      return (
        <LowestPriceFlexDatesTileVariant
          key={eachDate.formatDepartDateUrl}
          minRetailPrice={minRetailPrice}
          flexDate={eachDate.flexDate}
          flexDatePrice={eachDate.flexDatePrice}
          flexDatePriceExists={eachDate.flexDatePriceExists}
          isOriginalDepartDate={eachDate.isOriginalDepartDate}
          currencySymbol={eachDate.currencySymbol}
          flexDateDaysDiff={eachDate.flexDateDaysDiff}
          flexDateSearchUrl={eachDate.flexDateSearchUrl}
          navigateToFlexDateUrl={this.navigateToFlexDateUrl}
          numStops={eachDate.numStops}
          tripType={eachDate.tripType}
          hasLowestPrice={eachDate.hasLowestPrice}
          displaySavings={displaySavings}
          savings={savings}
        />
      )
    })

    if (isflexDatesAvailable) {
      if (!this.flexDateFlyqlOw && formatFlexDates.length) {
        this.flexDateFlyqlOw = true
      }

      return (
        <FlexContainerVariant
          updatedFlexDatesOWStyling={this.props.tripType === 'OW'}
          mb={2}
          data-autobot-element='flex-dates-tiles-wrapper'
          borderRadius='xl'
        >
          <Text pb={2} bold>
            Find the best day to travel
          </Text>
          <Box style={FlexDatesTilesContainerStyles}>
            <FlexDatesTilesWrapper borderRadius='xl'>
              {formatFlexDates}
            </FlexDatesTilesWrapper>
          </Box>
        </FlexContainerVariant>
      )
    }

    return null
  }

  navigateToFlexDateUrl = (e, url, gaTaggingLabel) => {
    e.preventDefault()
    flyGaLogic.fire.fireGenericListingsEvent(
      'suggested flex date display OW',
      gaTaggingLabel
    )

    if (url) {
      window.open(url, '_blank')
    }
  }

  render() {
    const { calendarPricing, minRetailPrice } = this.props

    // Return null if CalendarPricing array has empty Objects
    const calendarPricingNotEmpty =
      calendarPricing.length > 0 &&
      calendarPricing.some(calendarPricingNode => {
        return Object.keys(calendarPricingNode).length > 0
      })

    if (!calendarPricingNotEmpty || !minRetailPrice) {
      return null
    }

    return this.getFlexDates()
  }
}

FlexDatesTilesContainer.propTypes = {
  minRetailPrice: PropTypes.number.isRequired,
  minRetailStops: PropTypes.number,
  calendarPricing: PropTypes.array.isRequired,
  expressDealInfo: PropTypes.object,
  travelDate: PropTypes.string.isRequired,
  isFlexibleHeaderVariant: PropTypes.bool,
  tripType: PropTypes.string,
  searchOrigin: PropTypes.string,
  searchDestination: PropTypes.string,
  searchRequestCabinClass: PropTypes.string,
  searchRequest: PropTypes.object,
  enableSOPQ: PropTypes.bool,
}

export { FlexDatesTilesContainer }
